<div id="{{ menuModel.id }}-dropdown-wrapper"
     class="dropdown-menu-wrapper"
     [ngClass]="{'dropdown-menu-wrapper--relative': !overridePositioning, 'dropdown-menu-wrapper--max-width': fullWidth}">
    <button id="{{ menuModel.id + '-dropdown-link' }}"
            (click)="onToggleMenu(!opened, $event)"
            (keydown)="handleKey($event)"
            (focus)="handleFocus(true)"
            (blur)="handleFocus(false)"
            [ngClass]="[menuModel.linkCssClass, (isThemeEnabled && menuModel.themeCssClass && !opened) ? menuModel.themeCssClass : '', (opened && menuModel.openCssClass) ? menuModel.openCssClass : '']"
            [attr.aria-label]="menuModel.linkAriaLabel"
            keyboardFocusTooltip
            [attr.aria-expanded]="opened ? 'true' : 'false'"
            [attr.aria-describedby]="menuModel.id + '-button-description'"
            [title]="menuModel.linkTooltip || ''"
            data-clicklog="custom"
            #dropdownLink>
        <ng-content select="[ohpMenuLinkContent]"></ng-content>
    </button>
    <p class="aria-description" id="{{ menuModel.id + '-button-description' }}">{{ menuModel.linkAriaDescription }}</p>
    <ohp-menu *ngIf="opened && !mobileContextMenu && !hideContent" [menuModel]="menuModel" [leftAlignedCard]="leftAlignedCard" [multiSelect]="multiSelect" [ariaRole]="ariaRole" [selectedIndex]="selectedIndex" (selectItem)="onSelectItem($event)" (closeMenu)="onCloseMenu($event)" [animateClose]="true" [contextAriaLabel]="menuModel.linkAriaLabel">
        <ng-container *ohpMenuItemContent="let item = item; let index = index;">
            <ng-template [ngTemplateOutlet]="menuItemTemplate" [ngTemplateOutletContext]="{item: item, index: index}"></ng-template>
        </ng-container>
    </ohp-menu>
</div>
